module.exports = __webpack_public_path__ + "static/media/armretta.454fb011.png";